import { Type } from '@angular/core';
import { HandleEmailVerifiedService } from '@examdojo/auth';
import { SaveLastUsedAuthEffect } from '../auth/save-last-used-auth.effect';
import { AssessmentEffectService } from './assessment-effect.service';
import { ExamDatesEffectService } from './exam-dates-effect.service';
import { FetchAssignmentsOnSyllabusChangeEffectService } from './fetch-assignments-on-syllabus-change-effect.service';
import { FetchCategoryBoundariesOnSyllabusContextChangeEffectService } from './fetch-category-boundaries-on-syllabus-context-change-effect.service';
import { FetchCoursesOnProgramChangeService } from './fetch-courses-on-program-change.service';
import { FetchStreaksOnTimezoneChangeService } from './fetch-streaks-on-timezone-change.service';
import { FetchUserMarksOnSyllabusChangeEffectService } from './fetch-user-marks-on-syllabus-change-effect.service';
import { FetchUserMarksOnTimezoneChangeEffectService } from './fetch-user-marks-on-timezone-change.service';
import { ForceUpdateAppEffectService } from './force-update-app-effect.service';
import { PosthogUserTraitsService } from './posthog-user-traits.service';
import { RefreshTimeSensitiveUserDataOnDayChangeEffectService } from './refresh-time-sensitive-user-data-on-day-change.service';
import { RedirectOnFatalError } from './redirect-on-fatal-error.service';
import { ResetOnboardingStepWhenOnboarded } from './reset-onboarding-step-when-onboarded.service';

export const APP_EFFECTS: Array<Type<unknown>> = [
  PosthogUserTraitsService,
  HandleEmailVerifiedService,
  SaveLastUsedAuthEffect,
  RedirectOnFatalError,
  ResetOnboardingStepWhenOnboarded,
  ForceUpdateAppEffectService,
  FetchCategoryBoundariesOnSyllabusContextChangeEffectService,
  FetchAssignmentsOnSyllabusChangeEffectService,
  FetchUserMarksOnSyllabusChangeEffectService,
  FetchUserMarksOnTimezoneChangeEffectService,
  RefreshTimeSensitiveUserDataOnDayChangeEffectService,
  AssessmentEffectService,
  ExamDatesEffectService,
  FetchCoursesOnProgramChangeService,
  FetchStreaksOnTimezoneChangeService,
];
